function adjustSVGSize(svgElement) {
    if (!svgElement.hasAttribute('viewBox')) {
        console.error('SVG has no viewBox attribute');
        return;
    }
    
    let viewBoxValues = svgElement.getAttribute('viewBox').split(' ').map(parseFloat);
    if (viewBoxValues.length !== 4) {
        console.error('Invalid viewBox format');
        return;
    }
    
    let [, , viewBoxWidth, viewBoxHeight] = viewBoxValues;
    
    let targetWidth = 700;
    let targetHeight = (targetWidth / viewBoxWidth) * viewBoxHeight;
    
    if (targetHeight > 500) {
        targetHeight = 500;
        targetWidth = (targetHeight / viewBoxHeight) * viewBoxWidth;
    }
    
    svgElement.setAttribute('width', `${targetWidth}px`);
    svgElement.setAttribute('height', `${targetHeight}px`);
}

function updateSVGColor(svgElement, color) {
    // Aktualisiere alle path-Elemente
    svgElement.querySelectorAll('path').forEach(path => {
        path.setAttribute('fill', color);
    });
    
    // Aktualisiere auch alle rect-Elemente
    svgElement.querySelectorAll('rect').forEach(rect => {
        rect.setAttribute('fill', color);
        // Verwende style-Attribut mit höherer Priorität für stroke
        rect.style.stroke = color; 
        // Stelle sicher, dass der Stroke sichtbar ist, falls er nicht bereits gesetzt ist
        if (!rect.hasAttribute('stroke-width') || rect.getAttribute('stroke-width') === '0') {
            rect.style.strokeWidth = '1px';
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const svg = document.getElementById('svg-path');
    if (svg) {
        adjustSVGSize(svg);
    } else {
        console.error('SVG element not found');
    }
    
    document.querySelectorAll('.color-picker__input').forEach(input => {
        input.addEventListener('change', (event) => {
            const color = event.target.getAttribute('data-color');
            if (svg) {
                updateSVGColor(svg, color);
            }
        });
    });
});